import { from } from "rxjs";
import { dematerialize, materialize, mergeMapTo } from "rxjs/operators";
export function materializeTo(innerObservable) {
    return (source) => source.pipe(mergeMapTo(from(innerObservable).pipe(materialize())), dematerialize());
}
//# sourceMappingURL=materializeTo.js.map